import React from 'react';
import PropTypes from 'prop-types';

import './styles.css';

const BasicTitle = (props) => {
  const {
    text,
    styles,
    textStyles,
    uppercase = true,
    fontWeight = 700,
    fontSize,
  } = props;

  const cls = 'basic-title--text'
    + (uppercase ? ' basic-title--text--uppercase' : '')
    + (fontWeight ? ` basic-title--text--weight-${fontWeight}` : '')

  const tStyle = textStyles || {};
  if (fontSize) {
    tStyle.fontSize = typeof fontSize === 'number'
      ? `${fontSize}px`
      : fontSize;
  }

  return (
    <div className="basic-title" style={styles}>
      <span className={cls} style={tStyle}>{text}</span>
    </div>
  );
}

BasicTitle.propTypes = {
  text: PropTypes.string.isRequired,
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  textStyles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  uppercase: PropTypes.bool,
  fontWeight: PropTypes.oneOf([500, 700]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default BasicTitle;